import React from 'react'
import Title from './Title'

const company_projects = [
  {
    name: `Sea Dwelling Creatures`,
    image: `/static/seadwelling_creatures.png`,
    desc: `At a leading global wholesaler of marine and aquarium supplies, I contributed to a critical project involving the migration of code from PHP to Node.js, significantly enhancing performance. Implemented database transactions to ensure data integrity across various tables and seamlessly integrated third-party APIs such as Avalara (tax) and ShipEngine (shipping). Effectively monitored and optimized weekly Saturday sales and revenue, consistently surpassing $70,000 per week. Managed high traffic volumes with New Relic for comprehensive application monitoring.`,
    techs: `Node.js, Express, TPL, React, Redux, Bootstrap, WebSockets, Redis, MySQL, Cron, New Relic`,
  },
  {
    name: `Paymentgateway.com`,
    image: `/static/auctionsoftware.png`,
    desc: `As a part of my role, I successfully implemented payment intents and payouts while working with white-labeled software from Stripe and efficiently managed disputes . Additionally, I integrated Stripe Terminal into our system, enabling robust point-of-sale (POS) capabilities and facilitating smooth offline payments through card readers.`,
    techs: `Stripe, POS (Point of Sale), webhooks, Node.js, Express, React, Material UI, MySQL`,
  },
]

const Experience = () => {
  return (
    <div id='experience'>
      <Title title='Experience' />

      <div className=''>
        <div className='company_name'>
          <div className='flex align-items-center'>
            <img src='/static/accenture.svg' alt='Accenture' width={20} />
            <span>Accenture - Application Development Associate</span>
          </div>
          <p>11/09/2020 - 15/05/2021</p>
        </div>
        <div style={{ color: 'var(--rootTextColorLight', margin: '20px 0 40px 20px' }}>
          During my tenure at Accenture, I thrived as a Full Stack Developer, specializing in React and Node.js. The
          initial 3-month training provided a strong foundation, followed by hardlock to a project, where I implemented
          React-based frontend solutions. This experience enhanced my problem-solving skills, teamwork, and software
          development insights, shaping me into a more proficient Full Stack Developer.
        </div>
      </div>

      <div className=''>
        <div className='company_name'>
          <div className='flex align-items-center'>
            <img src='/static/develop_scripts.png' alt='develop_scripts' width={25} />
            <span>Develop Scripts LLC (US Based) - Software Developer</span>
          </div>
          <p>24/05/2021 - 28/07/2022</p>
        </div>
        <div className='projects_worked'>Projects worked on:</div>
        <div className='company_projects'>
          {company_projects.map((project) => (
            <div className='company_project' key={project.name}>
              <div className='flex align-items-center mb-10'>
                <img src={project.image} alt='' width={25} />
                <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>{project.name}</span>
              </div>
              <p className='company_project_desc'>{project.desc}</p>
              <p className='company_project_tech'>
                <span style={{ fontWeight: 'bold' }}>Technologies used:</span> {project.techs}
              </p>
            </div>
          ))}
        </div>
      </div>
      <br />
      <br />
      <div>
        <div className='company_name'>
          <div className='flex align-items-center'>
            <img src='/static/career-break.webp' alt='career_break' width={25} style={{ borderRadius: '50%' }} />
            <span>Planned Career Break ( Freelance / Professional Development )</span>
          </div>
          <p>08/2022 - present</p>
        </div>
        <div className='projects_worked'>Information:</div>
        <ul style={{ color: 'var(--rootTextColorLight', margin: '20px 0 0 20px' }}>
          <li className='mb-10'>
            I have undertaken side projects for an Instagram business called YaazhProducts and few freelance work,
            showcasing my web development skills.
          </li>
          <li>
            Additionally, I have proactively upskilled myself by completing online courses in Docker, Next.js, GitHub
            Actions, PostgreSQL, AWS etc, enhancing my expertise in building and deploying applications with
            cutting-edge technologies.
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Experience
